// config.js - Central configuration for the application
// "https://backend-99875845583.us-central1.run.app"
// API URL - Use environment variable with fallback to localhost for development
// const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = "http://localhost:5002";
// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5002";
const API_URL = process.env.REACT_APP_API_URL || "https://cs411-backend.duckdns.org";

// Exports
export { API_URL };
